import { ArgsType, Field } from '@nestjs/graphql'
import { CategoryReorderInput } from './reorder.input'

@ArgsType()
export class ReorderCategoriesDto {
  @Field(() => [CategoryReorderInput])
  items!: CategoryReorderInput[]
}
